import { useCallback, useEffect, useRef } from "react";
import { useThree } from "@react-three/fiber";
import useHashLocation from "../use-hash-location";
import store from "../appStore";

export function useInactivity(onInactive, timeoutMs = import.meta.env.VITE_INTERACTION_TIMEOUT || 10000) {
  const timerRef = useRef<NodeJS.Timeout>();
  const { gl } = useThree();

  const resetTimer = useCallback(() => {
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(onInactive, timeoutMs);
  }, [timeoutMs, onInactive]);

  useEffect(() => {
    resetTimer();

    const window_events = ["mousemove", "mousedown", "keydown", "touchstart", "wheel", "scroll"];
    window_events.forEach((e) => window.addEventListener(e, resetTimer, { passive: true }));

    const canvas = gl.domElement;

    const canvas_events = ["pointermove", "pointerdown", "wheel"];
    canvas_events.forEach((e) => canvas.addEventListener(e, resetTimer, { passive: true }));

    return () => {
      clearTimeout(timerRef.current);
      window_events.forEach((e) => window.removeEventListener(e, resetTimer));
      canvas_events.forEach((e) => canvas.removeEventListener(e, resetTimer));
    };
  }, [resetTimer]);

  return resetTimer; // expose so Three.js events can call it too
}

export const TimeoutReset = () => {
  const [_loc, navigate] = useHashLocation();
  const handleInactive = () => {
    if (import.meta.env.MODE !== "electron") {
      return;
    }
    if (store.autoPlay) {
      console.log("Would like to cancel but autoplay is on");
      return;
    }
    navigate("/");
    console.log("User is inactive!");
  };
  useInactivity(handleInactive);

  return null;
};
